module.exports = __webpack_public_path__ + "static/media/snowboard.5c68be8b.avif";